<template>
  <section>
    <!-- Main navbar -->
    <top-menu></top-menu>

    <!-- Page content -->
    <div class="page-content">
      <!-- Main sidebar -->

      <div class="content-wrapper">
        <div class="content">
          <slot />
        </div>
      </div>
    </div>
    <!-- /page content -->
  </section>
</template>

<script>
import TopMenu from "./admin/TopMenu";
import LeftMenu from "./admin/LeftMenu";
import HeaderContent from "./admin/HeaderContent";
import FooterContent from "./admin/FooterContent";

export default {
  name: "AdminLayoutNoHeader",
  components: {
    TopMenu,
    LeftMenu,
    HeaderContent,
    FooterContent,
  },
};
</script>
<style scoped>
.navbar.navbar-expand-md {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/layouts/tenancy/AdminLayoutNoHeader.vue